import React from 'react';
import SidebarQuickNotesUtil from './SidebarQuickNotesUtil';
import { useSelector } from 'react-redux';

// Types
import { SidebarProps } from './Sidebar';

// Components
import SidebarArchivePopupUtil from './SidebarArchivePopupUtil';
import NotificationsUtil from '../workspace/header/workspaceToolsHeader/notifications/NotificationsUtil';
import HelpUtil from '../workspace/header/workspaceToolsHeader/help/HelpUtil';
import AccountUtil from '../workspace/header/workspaceToolsHeader/account/AccountUtil';
import SearchUtil from '../workspace/header/workspaceToolsHeader/boardSearch/BoardSearchUtil';
import SharedBoardsPopupUtil from './SharedBoardsPopupUtil';

// Selectors
import { getIsUtilPopupOpened } from '../workspace/header/utilPopupSelector';

// Styles
import './SidebarBottom.scss';

const SidebarBottom: React.FC<SidebarProps> = (props) => {
    const { currentUser, currentBoardId, pageTitle } = props;

    const utilPopupOpened = useSelector(getIsUtilPopupOpened);

    return (
        <div className="SidebarBottom">
            <SidebarQuickNotesUtil {...props} />
            <SidebarArchivePopupUtil {...props} />
            <SharedBoardsPopupUtil {...props} />
            <div className="divider"></div>
            <div className="tools-section">
                <SearchUtil
                    currentUser={currentUser}
                    currentBoardId={currentBoardId}
                    tooltipEnabled={!utilPopupOpened}
                />
                <AccountUtil currentUser={currentUser} tooltipEnabled={!utilPopupOpened} />
                <HelpUtil tooltipEnabled={!utilPopupOpened} />
                <NotificationsUtil pageTitle={pageTitle} currentUser={currentUser} tooltipEnabled={!utilPopupOpened} />
            </div>
        </div>
    );
};

export default SidebarBottom;
